import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
interface FooterLink {
  label: string;
  href: string;
}
const LEGAL_LINKS: FooterLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="bg-sand" data-id="element-60" data-mp="36nd1p6jrvpxv">
      <div className="mx-auto max-w-5xl px-5 py-10 sm:py-12" data-id="element-61" data-mp="3ug3etj3ewf9q">
        <div className="flex flex-col gap-7 sm:flex-row sm:items-start sm:justify-between" data-id="element-62" data-mp="38quiv78flpl">
          <div data-id="element-63" data-mp="36czunggsbik">
            <p className="font-display text-[1.15rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal sm:text-[1.35rem]" data-id="element-64" data-mp="3lelzi2xtwhm3">
              200 Fórmulas de <span className="text-gold-deep" data-id="element-65" data-mp="3qbly5sscmi36">Velas Artesanales</span>
            </p>
            <p className="mt-2 font-sans text-[0.8rem] text-taupe" data-id="element-66" data-mp="29xlzsm95j0i1">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-bold text-gold-deep transition-colors duration-200 ease-out hover:text-charcoal focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-67" data-mp="2ezutxlxrg8lq">
                Creativo Digital™
              </a>
            </p>
          </div>

          <ul className="space-y-2 text-[0.82rem]" data-id="element-68" data-mp="830iphfda2zy">
            <li data-id="element-69" data-mp="81fojswysm2m">
              <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-70" data-mp="80xjq7w8kzj3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-71" data-mp="qti0iqynve6j">
                  <MailIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-72" data-mp="ms6h536drp6s" />
                </span>
                soporte@creativodigital.shop
              </a>
            </li>
            <li data-id="element-73" data-mp="yu7j4w3bzy0b">
              <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-74" data-mp="yto9s3rqyhxw">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-75" data-mp="1hk5w9qlzkhat">
                  <InstagramIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-76" data-mp="1mjilgi0by0gk" />
                </span>
                @creativodigitalstudio
              </a>
            </li>
            <li data-id="element-77" data-mp="3obokn8k2l5dv">
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-78" data-mp="3oc6r0y0g4zzi">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-79" data-mp="21m0kdwb8jgvu">
                  <GlobeIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-80" data-mp="1worwrg7bikn7" />
                </span>
                www.creativodigital.shop
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-stone pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-81" data-mp="2pcw5ybp3lfun">
          <ul className="flex flex-wrap gap-x-4 gap-y-1.5 font-sans text-[0.74rem] text-taupe/80" data-id="element-82" data-mp="2kfe3931obwv3">
            {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-83" data-mp="18yeeuiig626c">
                <a href={link.href} className="transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-84" data-mp="18zfrgrf42wq6">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <p className="font-sans text-[0.74rem] text-taupe/80" data-id="element-85" data-mp="2ivkyk6ejccmi">
            © Creativo Digital™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}